// extracted by mini-css-extract-plugin
module.exports = {"tech":"Tech_tech__3DoSI","tech__content":"Tech_tech__content__3s6SH","tech__techSkills":"Tech_tech__techSkills__zIzNG","tech__skill":"Tech_tech__skill__3sMiA"};